var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-checkbox-box"},[_c('wt-check-box',{attrs:{"checked":_vm.checkboxChecked,"disabled":_vm.checkboxDisabled,"label-right":_vm.checkboxLabel},on:{"changed":_vm.changed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }